import { userForgetPasswordReset, userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import { postJwtForgetPwd } from "../../../helpers/fakebackend_helper";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('auth_messages');

const fireBaseBackend : any= getFirebaseBackend();

// Mã lỗi (field "code" trong response của POST /Auth/forgot-password) => key text trong
// src/locales/screens.json (mục "auth_messages"). Muốn đổi nội dung thông báo chỉ cần sửa file JSON.
const FORGOT_PASSWORD_ERROR_KEYS: Record<string, string> = {
  INVALID_INFO: 'forgot_password_invalid_info_message',
  INVALID_INPUT: 'forgot_password_invalid_input_message',
  EMAIL_NOT_CONFIGURED: 'forgot_password_email_not_configured_message',
};

export const userForgetPassword = (user : any, history : any) => async (dispatch : any) => {
  dispatch(userForgetPasswordReset());
  try {
      let response;
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {

          response = fireBaseBackend.forgetPassword(
              user.email
          )

      } else {
          // Luôn gọi API thật của identity-service (/identity-api/Auth/forgot-password). Trước đây chỉ gọi khi
          // REACT_APP_DEFAULTAUTH === "jwt"; còn .env đang đặt "fake" nên rơi vào /auth/forgot-password
          // (không tồn tại ở gateway) => lỗi 404. Trang đặt lại mật khẩu (ResetPassword.tsx) cũng gọi thẳng API thật.
          // BE chỉ gửi mail khi tên đăng nhập VÀ email khớp cùng 1 tài khoản.
          response = await postJwtForgetPwd({ username: user.username, email: user.email })
      }

      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(st('forgot_password_success_message')))
      }
  } catch (forgetError) {
      const error: any = forgetError;
      const textKey = FORGOT_PASSWORD_ERROR_KEYS[error?.data?.code];
      dispatch(userForgetPasswordError(
        textKey ? st(textKey) : (error?.data?.message || error?.message || st('khong_gui_duoc_yeu_cau_dat_text'))
      ))
  }
}
